module.exports = __webpack_public_path__ + "media/images/talent/img-mv-a735887e5542cf7f15a2ad41e9ea60e0.png";